import { LocationModelPublicationType } from '@kcftech/prometheus-client';
import { useMutation } from '@tanstack/react-query';
import { DropdownInlineEditor } from 'components/inline_edit/DropdownInlineEditor';
import { useNotificationContext } from 'contexts/NotificationContext';
import { usePermissions } from 'contexts/PermissionsContext';
import { LocationsTableCellProps } from 'pages/Settings/Locations/LocationsTable';
import { updateLocation } from 'utils/location';

type Option = {
    value: LocationModelPublicationType;
    label: string;
};

const options: Option[] = [
    { value: LocationModelPublicationType.None, label: 'None' },
    { value: LocationModelPublicationType.Auto, label: 'Auto' },
];

export function LocationModelPublicationCell({
    rowData,
    onChange,
}: LocationsTableCellProps) {
    const { canEditLocationDetails } = usePermissions();
    const selectedOption = options.find(
        (option) => option.value === rowData.Settings.ModelPublication,
    );
    const { showToast } = useNotificationContext();
    const { mutate: updateModelPublication, isPending } = useMutation({
        meta: { name: 'update-location' },
        mutationFn: (modelPublication: Option | undefined) =>
            updateLocation(rowData, {
                ModelPublication:
                    modelPublication?.value ?? LocationModelPublicationType.None,
            }),

        onSuccess: () => {
            onChange();
        },

        onError: () =>
            showToast({
                type: 'error',
                content: 'Failed to save location model publication',
            }),
    });

    return (
        <DropdownInlineEditor
            options={options}
            dropdownConfig={{
                renderLabel: ({ value }) => value?.label ?? 'None',
                dataKey: (item) => item.value,
                renderItem: ({ item }) => item.label,
                popup: { width: '16rem' },
            }}
            value={selectedOption}
            renderValue={(value) => value?.label ?? 'None'}
            onConfirm={updateModelPublication}
            isDisabled={isPending || !canEditLocationDetails}
        />
    );
}
